export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Portal/index.js
// module id = 268
// module chunks = 22